import React from 'react';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Table } from 'reactstrap';
import { H5, P, Image } from '../../../AbstractElements';
import { BestSellingProductTitle, OurBestSellerDetailsList } from '../../../Constant';
import { BEST_SELLING_PRODUCT } from '../../../Data/DashBoard/Default/Table';
import { DigitFix } from '../../../Utils/helper/DigitFix';
import SellingList from './SellingList';

const BestSellingProduct = () => {
  return (
    <>
      <Col xl='6' className='box-col-12 best-selling'>
        <Card className='bestselling-sec'>
          <CardHeader className='p-b-0'>
            <H5>{BestSellingProductTitle}</H5>
            <div className='center-content'>
              <P>{OurBestSellerDetailsList}</P>
            </div>
            <SellingList />
          </CardHeader>
          <CardBody className='pt-0'>
            <div className='bestselling-table table-responsive'>
              <Table className='table table-bordernone'>
                <tbody>
                  {BEST_SELLING_PRODUCT.map((item, i) => (
                    <tr key={i}>
                      <td>
                        <span>{DigitFix(i + 1)}</span>
                        <div className='t-title ms-3'>
                          <Image className='img-40 rounded-circle align-top' src={item.image} alt='product' />
                          <div className='d-inline-block align-middle'>
                            <Link to={`${process.env.PUBLIC_URL}/ecommerce/product`}>
                              <span className='ms-3 d-block'>{item.title}</span>
                            </Link>
                          </div>
                        </div>
                      </td>
                      <td>{item.date}</td>
                      <td>
                        {item.gros < 40 ? <FaArrowDown className='font-danger me-1' /> : <FaArrowUp className='font-primary me-1' />}
                        {`${DigitFix(item.gros.toFixed(2))}%`}
                      </td>
                      <td>{item.status}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default BestSellingProduct;
